import { useEffect, useState } from 'react';

import { useFormContext } from 'react-hook-form';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { RouterParams } from 'containers/AppRouter';
import InputForm from 'shared/components/Input/InputForm';
import Loader from 'shared/containers/Loader';
import { GENERAL_INFO_TITLE, SETTINGS_TITLE } from 'shared/containers/ViewDetails/ViewDetails';
import { APIErrorT } from 'shared/models/api';
import { DeviceConfigT } from 'shared/models/device-configs';
import * as Source from 'shared/models/sources';
import api from 'utils/api';

import { FormValuesT } from '../DeviceConfigManageData.validator';

interface DeviceConfigItemFormOneProps {
  isEdit: boolean;
  deviceProfileId: string;
  sourceTechnology: string; // From selected Flow
}
function DeviceConfigItemFormOne({
  isEdit,
  deviceProfileId,
  sourceTechnology,
}: DeviceConfigItemFormOneProps) {
  const {
    register,
    setValue,
    formState: {
      errors,
    },
  } = useFormContext<FormValuesT>();
  const history = useHistory();
  const { flowId } = useParams() as RouterParams;

  const [loadingState, setLoadingState] = useState<number>(0);
  const [defaultValueIPv4, setDefaultValueIPv4] = useState('');
  const [defaultValueIPv6, setDefaultValueIPv6] = useState('');
  const nextLoadingState = () => setLoadingState((count) => count + 1);

  const loadDeviceProfileFromIPNetwork = () => {
    const request = api.deviceProfiles.getIpFromIPNetwork(
      flowId as string, deviceProfileId as string,
    );
    request
      .then((resp: any) => {
        if (resp.status >= 400) {
          resp.json()
            .then((error: APIErrorT) => {
              toast.error(error?.message);
            })
            .catch(() => {
              toast.error('Get IP from IP Network failed');
              history.goBack();
            });
          nextLoadingState();
        } else {
          resp.json()
            .then((deviceConfig: DeviceConfigT) => {
              const IPv6 = deviceConfig.addressIPv6;
              const IPv4 = deviceConfig.addressIPv4;
              setValue('addressIPv6', IPv6);
              setValue('addressIPv4', IPv4);
              setDefaultValueIPv6(IPv6);
              setDefaultValueIPv4(IPv4);
              nextLoadingState();
            });
        }
      });
  };

  useEffect(() => {
    loadDeviceProfileFromIPNetwork();
  }, []);

  if (loadingState < 1) {
    return <Loader.Section />;
  }
  return (
    <>
      <div className="form__section" style={{ marginTop: '1rem' }}>
        <h3>{ GENERAL_INFO_TITLE }</h3>
        <InputForm.TextField
          fullWidth
          sx={{ m: 1 }}
          label="Name"
          register={register('name')}
          errorField={errors.name}
        />
        <InputForm.TextField
          fullWidth
          sx={{ m: 1 }}
          label="Description"
          register={register('comment')}
          errorField={errors.comment}
        />
      </div>
      <div className="form__section" style={{ marginTop: '1rem' }}>
        <h3>{ SETTINGS_TITLE }</h3>
        <InputForm.TextField
          fullWidth
          sx={{ m: 1 }}
          label="Device ID"
          register={register('deviceId')}
          errorField={errors.deviceId}
          helperText={Source.getDeviceIDRequirement(sourceTechnology).defaultHelper}
          disabled={isEdit}
        />
        {
          defaultValueIPv4
            ? (
              <InputForm.TextField
                fullWidth
                sx={{ m: 1 }}
                label="IPv4 Address"
                register={register('addressIPv4')}
                defaultValue={defaultValueIPv4}
                errorField={errors.addressIPv4}
                errorSuffix={` - Default value: ${defaultValueIPv4}`}
                disabled={isEdit}
                required
              />
            )
            : null
        }
        {
          defaultValueIPv6
            ? (
              <InputForm.TextField
                fullWidth
                sx={{ m: 1 }}
                label="IPv6 Address"
                register={register('addressIPv6')}
                defaultValue={defaultValueIPv6}
                errorField={errors.addressIPv6}
                errorSuffix={` - Default value: ${defaultValueIPv6}`}
                disabled={isEdit}
                required
              />
            )
            : null
        }
      </div>
    </>
  );
}

export default DeviceConfigItemFormOne;
